//Please add the language resource
const invoice = {
  rebateAmount:'RebateAmount',
  billMonth:'BillMonth',
  paymentAmount:'PaymentAmount',
  salesAmount:'SalesAmount',
  endingBalance:'EndingBalance',
  beginningBalance:'BeginningBalance',
  confirmStatus:'ConfirmStatus',
  priceDueDate:'PriceDueDate',
  reference:'Reference',
  currencyType:'CurrencyType',
  sapNo:'SapNo',
  postDate:'PostDate',
  orderAmount:'OrderAmount',
  goldenTaxDate:'GoldenTaxDate',
  goldenTaxNumber:'GoldenTaxNumber',
  billRange:'BillRange',
  financialVoucherNo:'FinancialVoucherNo',
  type:'Type',
  textData:'TextData',
  msg:{
  }
};
export default invoice



// WEBPACK FOOTER //
// ./src/page/finance/invoice/lang/invoice.en.js